import { useState } from 'react'
import Modal from './Modal'
import { LoginForm } from '../pages/Login'
import { RegisterForm } from '../pages/Register'

export default function Footer() {
	const [showLogin, setShowLogin] = useState(false)
	const [showRegister, setShowRegister] = useState(false)
	return (
		<footer className="mt-10 py-8 bg-white/95 border-t border-black/5">
			<div className="max-w-6xl mx-auto px-4">
				<div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-black mb-3">
					<p className="text-sm">© {new Date().getFullYear()} DateShake</p>
					<div className="flex items-center gap-4">
						<button className="underline" onClick={() => setShowRegister(true)}>Get Started</button>
						<button className="underline" onClick={() => setShowLogin(true)}>Login</button>
					</div>
				</div>
			</div>
			<Modal isOpen={showRegister} onClose={() => setShowRegister(false)} title="Create your account">
				<RegisterForm />
			</Modal>
			<Modal isOpen={showLogin} onClose={() => setShowLogin(false)} title="Sign in">
				<LoginForm />
			</Modal>
		</footer>
	)
}


